import { __decorate, __metadata } from 'tslib';
import React, { PureComponent } from 'react';
import { Inject } from '@tencent/ioc';
import { setActionPointEvent } from '../../providers/action-point/action-point-runner.js';
import { TitlebarService } from '../../services/titlebar/titlebar-service.js';
import { WorkbenchConfigurationState } from '../../services/settings/auto-sync-settings.js';
import styles from './titlebar.less.js';
import { evaluate } from '../../controllers/base/evaluate.js';
import { withState } from '../../services/store/with-state.js';
import { ResizeObserver } from '../../utils/resize-observer.js';

class TitlebarContentComponent extends PureComponent {
    constructor() {
        super(...arguments);
        this.ref = React.createRef();
        this.handleClick = (event) => {
            if (this.props.preventOriginalClick) {
                event.stopPropagation();
            }
            if (this.props.disabled) {
                return;
            }
            const { onClick } = this.props;
            setActionPointEvent(onClick, event);
            onClick === null || onClick === void 0 ? void 0 : onClick();
            this.titlebarService.setHoverActive(false);
        };
    }
    componentDidMount() {
        this.sensor = new ResizeObserver(() => {
            var _a, _b;
            if (this.props.visible === false)
                return;
            if (!this.ref.current)
                return;
            const style = getComputedStyle(this.ref.current);
            const width = this.ref.current.clientWidth;
            const outerWidth = parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
            this.titlebarService.updateWidth(this.props, width, outerWidth);
            (_b = (_a = this.props).onWidthChange) === null || _b === void 0 ? void 0 : _b.call(_a, width);
        });
        if (this.ref.current) {
            this.sensor.observe(this.ref.current);
        }
    }
    componentDidUpdate(prevProps) {
        var _a, _b, _c;
        if (prevProps.visible !== this.props.visible) {
            (_b = (_a = this.props).onVisibleChange) === null || _b === void 0 ? void 0 : _b.call(_a, (_c = this.props.visible) !== null && _c !== void 0 ? _c : true);
        }
    }
    componentWillUnmount() {
        this.titlebarService.updateWidth(this.props, 0, 0);
        this.sensor.disconnect();
    }
    getAriaAttributes() {
        var _a;
        const result = {};
        const { ariaLabel, tooltip, content, onClick, } = this.props;
        if (onClick) {
            result.role = 'button';
        }
        if (this.props.disabled) {
            result['aria-disabled'] = this.props.disabled;
        }
        const defaultTip = typeof tooltip === 'string' ? tooltip : undefined;
        const text = typeof content === 'string' ? content : undefined;
        const defaultLabel = (_a = ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : text) !== null && _a !== void 0 ? _a : defaultTip;
        if (defaultLabel) {
            result['aria-label'] = defaultLabel;
        }
        return result;
    }
    render() {
        const { content, style } = this.props;
        const containerStyle = style !== null && style !== void 0 ? style : {};
        let element = content;
        if (React.isValidElement(element)) {
            element = React.cloneElement(element, {
                disabled: this.props.disabled,
            });
        }
        const hiddenStyle = this.props.visible === false
            ? {
                maxWidth: 0,
                minWidth: 0,
                margin: 0,
                overflow: 'hidden',
            }
            : {};
        return (React.createElement("div", Object.assign({ onClickCapture: this.handleClick, ref: this.ref }, this.getAriaAttributes(), { style: Object.assign(Object.assign(Object.assign(Object.assign({}, this.props['titlebar.contentDefaultStyle']), containerStyle), { flexBasis: this.props.shrinkable !== 'continuous' ? this.props.width : undefined, flexShrink: this.props.shrinkable === 'continuous' ? 1 : 0, maxWidth: this.props.width }), hiddenStyle), className: styles['titlebar-content'] }), element));
    }
}
__decorate([
    Inject(),
    __metadata("design:type", TitlebarService)
], TitlebarContentComponent.prototype, "titlebarService", void 0);
const TitlebarContent = withState([
    WorkbenchConfigurationState.TitlebarContentDefaultStyle,
])(TitlebarContentComponent);
function getTitleBarContentProps(item) {
    return Object.assign(Object.assign({}, item), { tooltip: evaluate(item.tooltip, ''), disabled: evaluate(item.shouldDisabled, false), style: evaluate(item.style, undefined), content: evaluate(item.content, undefined) });
}

export { TitlebarContent, getTitleBarContentProps };
//# sourceMappingURL=titlebar-content.js.map
